import cn from "classnames"

import { Headline4 } from "ui-kit/components-branded/Headline"

interface Props {
    tabs: { name: string; disabled: boolean }[]
    currentTab: string
    onHeaderClick: (tab: string) => void
}

export function Tabs({ tabs, currentTab, onHeaderClick }: Props) {
    return (
        <div className="tabs blm-tabs is-justify-content-flex-start">
            {tabs.map((tab) => (
                <Headline4
                    key={tab.name}
                    onClick={() => onHeaderClick(tab.name)}
                    className={cn("blm-tabs__tab", {
                        "blm-tabs__tab--active": tab.name === currentTab,
                        "blm-tabs__tab--disabled": tab.disabled,
                    })}
                >
                    {tab.name}
                    <div
                        className={cn("blm-tabs__tab-custom-border", {
                            "blm-tabs__tab-custom-border-visibility-hidden":
                                tab.name !== currentTab,
                        })}
                    />
                </Headline4>
            ))}
        </div>
    )
}
